import { Controller } from '@hotwired/stimulus';
import { post } from '@rails/request.js';

export default class extends Controller {
  static targets = ['banner'];
  static values = { dismissUrl: String };

  async close() {
    this.bannerTarget.remove();

    try {
      await post(this.dismissUrlValue);
    } catch (error) {
      console.warn('Failed to persist banner dismissal:', error);
    }
  }
}
